import { elektraAppQueryOptions } from '@connected/elektra-sdk/queries/query-options';
import { useSuspenseQuery } from '@tanstack/react-query';

import type { Option } from '@/hooks/use-option';

import { useSelectableOptions } from '@/hooks/use-option';
import { queryClient } from '@/lib/query-client';

export function useAdditionalTopics(projectVersionId: string) {
    const additionalTopics = useSuspenseQuery(
        elektraAppQueryOptions.project.selectListsItems.selectListsItemsGetOptions({
            electricalProjectVersionId: projectVersionId,
            listKind: 'AdditionalTopic',
        }),
    );

    const additionalTopicOptions = useSelectableOptions({
        options:
            additionalTopics.data?.Items.map(item => ({
                value: item.ElectricalProjectSelectListItemId!,
                label: item.Label!,
            })) || ([] as Option<string>[]),
        initialSelectedValues:
            additionalTopics.data?.Items.filter(x => x.Selected).map(
                x => x.ElectricalProjectSelectListItemId!,
            ) ?? [],
        selectItemType: 'AdditionalTopic',
        electricalProjectVersionId: projectVersionId,
        parentKind: 'RequestConcerning',
        scopeIdentifiers: {
            ElectricalProjectVersionId: projectVersionId,
        },
    });

    function handleChange(values: string[]) {
        additionalTopicOptions.onChange(values);

        queryClient.invalidateQueries(
            elektraAppQueryOptions.project.selectListsItems.selectListsItemsGetOptions({
                electricalProjectVersionId: projectVersionId,
                listKind: 'AdditionalTopic',
            }),
        );
    }

    return {
        options: additionalTopicOptions?.options,
        selectedValues: additionalTopicOptions?.selectedValues,
        handleChange,
    };
}
